/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  CLINICAL_TRIAL_DESIGN_SUB_GROUP_SHELL_KEYS,
  CROSS_LICENSE_AGREEMENT_SUP_GROUP_SHELL_KEYS,
  ENTRY_DATA_CLINICAL_TRIAL_DESIGN,
  ENTRY_DATA_CLINICAL_TRIAL_DESIGN_2_KEYS,
  ENTRY_DATA_CLINICAL_TRIAL_DESIGN_KEYS,
  ENTRY_DATA_CONTINGENT_PAYMENT_KEYS,
  ENTRY_DATA_DESIGN_GROUP_INFORMATION_KEYS,
  ENTRY_DATA_LICENSEE_TABLE,
  ENTRY_DATA_LICENSEE_TABLE_KEYS,
  ENTRY_DATA_MERGE_ACQUISITION_TERMS_KEYS,
  ENTRY_DATA_OTHER_PAYMENT_DETAIL_KEYS,
  ENTRY_DATA_SECTION_KEYS,
  ENTRY_DATA_STRATEGIC_COLLABORATION_LICENSE_AGREEMENT_TERMS_KEYS,
  ENTRY_DATA_VENTURE_FORMATION_TERMS_KEYS,
  LICENSE_AGREEMENT_SUP_GROUP_SHELL_KEYS,
  MERGE_ACQUISITION_SUB_GROUP_SHELL_KEYS,
  VENTURE_FORMATION_SUB_GROUP_SHELL_KEYS,
} from "@frontend/common";

import { ArticleEntryData } from "@/types/articleEntryData.types";
import { ArmValue } from "@/types/clinicalTrials.types";
import {
  DealLaScAdvisorTableValue,
  DealLaScMilestonePaymentAndDetailSubGroupValue,
  DealLaScOtherPaymentAndDetailSubGroupValue,
  DealLaScPartnerAValue,
  DealLaScPartnerBValue,
  DealLaScPartnerCValue,
  DealLaScRightsScopeTableValue,
  DealLaScRoyaltySubGroupValue,
} from "@/types/dealLaSc.types";
import {
  ContingentInvestmentVf,
  ContingentPayment,
  DealsAdvisorTableValue,
  LicenseeMAValue,
  LicenseeVfValue,
  LicensorMAValue,
  LicensorVfValue,
  MilestonePaymentAndCondition,
  OtherPaymentAndDetail,
  RightsScope,
} from "@/types/deals.types";
import { createRandomString } from "@organisms/TableCreatorComment/components/CommentModalContainer/components/CommentModalMessageComposer/utils/createRandomString";

import { EXPEDITED_PROGRAM } from "./expeditedProgramKey.constants";

export const TABLE_CREATOR_SUB_GROUP_SHELL = {
  "Clinical Trials": [
    {
      key: CLINICAL_TRIAL_DESIGN_SUB_GROUP_SHELL_KEYS.arm,
      title: "arm",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
  ],
  "Clinical Trial Status": [],
  Regulatory: [],
  Deals: [
    {
      key: LICENSE_AGREEMENT_SUP_GROUP_SHELL_KEYS.milestone,
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: LICENSE_AGREEMENT_SUP_GROUP_SHELL_KEYS.otherPaymentAndDetail,
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: MERGE_ACQUISITION_SUB_GROUP_SHELL_KEYS.contingentPayment,
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: CROSS_LICENSE_AGREEMENT_SUP_GROUP_SHELL_KEYS.rightsScopePartnerA,
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: CROSS_LICENSE_AGREEMENT_SUP_GROUP_SHELL_KEYS.rightsScopePartnerB,
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: VENTURE_FORMATION_SUB_GROUP_SHELL_KEYS.contingentInvestment,
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: "Licensee(MA)",
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: "Licensor(MA)",
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: "Licensee(VF)",
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: "Licensor(VF)",
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: "Asset Transfer Row",
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: "Advisor Table",
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: "Advisor",
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: "Key Comment List",
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
  ],
  [ENTRY_DATA_SECTION_KEYS.dealsLaSc]: [
    {
      key: "Milestone Payment And Detail",
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: "Other Payment And Detail",
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: "Royalty(LA&SC)",
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: "Rights Scope",
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: "Advisor",
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: "Partner A",
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: "Partner B",
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: "Partner C",
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
  ],
  "Deal Filing": [
    {
      key: LICENSE_AGREEMENT_SUP_GROUP_SHELL_KEYS.milestone,
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: LICENSE_AGREEMENT_SUP_GROUP_SHELL_KEYS.otherPaymentAndDetail,
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: MERGE_ACQUISITION_SUB_GROUP_SHELL_KEYS.contingentPayment,
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: CROSS_LICENSE_AGREEMENT_SUP_GROUP_SHELL_KEYS.rightsScopePartnerA,
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: CROSS_LICENSE_AGREEMENT_SUP_GROUP_SHELL_KEYS.rightsScopePartnerB,
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
    {
      key: VENTURE_FORMATION_SUB_GROUP_SHELL_KEYS.contingentInvestment,
      title: "",
      isRequired: false,
      isReviseSubGroupShell: true,
    },
  ],
  [EXPEDITED_PROGRAM]: [],
  [ENTRY_DATA_SECTION_KEYS.ventureCapital]: [],
  [ENTRY_DATA_SECTION_KEYS.fundingFiling]: [],
  [ENTRY_DATA_SECTION_KEYS.publication]: [],
  [ENTRY_DATA_SECTION_KEYS.regulatoryLabel]: [],
  [ENTRY_DATA_SECTION_KEYS.publicationJournal]: [],
  [ENTRY_DATA_SECTION_KEYS.conferenceSchedule]: [],
  [ENTRY_DATA_SECTION_KEYS.ctg]: [],
};

export const SUB_GROUP_SHELL_PATH_TO_ADD_SUB_GROUP_SHELL: Record<
  string,
  (
    data: ArticleEntryData,
    tableIndex: number,
    groupShellIndex: number,
  ) => unknown[]
> = {
  "Milestone Payment And Detail": (
    data: ArticleEntryData,
    tableIndex: number,
    groupShellIndex: number,
  ) => {
    return (
      data?.[ENTRY_DATA_SECTION_KEYS.dealsLaSc]?.[
        "Main Financial Terms Table"
      ]?.[groupShellIndex]["Milestone Payment And Detail"] || []
    );
  },
  "Other Payment And Detail": (
    data: ArticleEntryData,
    tableIndex: number,
    groupShellIndex: number,
  ) => {
    return (
      data?.[ENTRY_DATA_SECTION_KEYS.dealsLaSc]?.[
        "Main Financial Terms Table"
      ]?.[groupShellIndex]["Other Payment And Detail"] || []
    );
  },
  "Partner A": (
    data: ArticleEntryData,
    tableIndex: number,
    groupShellIndex: number,
  ) => {
    return (
      data?.[ENTRY_DATA_SECTION_KEYS.dealsLaSc]?.["Partner Axis"]?.[
        "Partner A"
      ] || []
    );
  },
  "Partner B": (
    data: ArticleEntryData,
    tableIndex: number,
    groupShellIndex: number,
  ) => {
    return (
      data?.[ENTRY_DATA_SECTION_KEYS.dealsLaSc]?.["Partner Axis"]?.[
        "Partner B"
      ] || []
    );
  },
  "Partner C": (
    data: ArticleEntryData,
    tableIndex: number,
    groupShellIndex: number,
  ) => {
    return (
      data?.[ENTRY_DATA_SECTION_KEYS.dealsLaSc]?.["Partner Axis"]?.[
        "Partner C"
      ] || []
    );
  },
  "Royalty(LA&SC)": (
    data: ArticleEntryData,
    tableIndex: number,
    groupShellIndex: number,
  ) => {
    return (
      data?.[ENTRY_DATA_SECTION_KEYS.dealsLaSc]?.[
        "Main Financial Terms Table"
      ]?.[groupShellIndex]["Royalty(LA&SC)"] || []
    );
  },
  Advisor: (
    data: ArticleEntryData,
    tableIndex: number,
    groupShellIndex: number,
  ) => {
    return data?.[ENTRY_DATA_SECTION_KEYS.dealsLaSc]?.["Advisor Table"] || [];
  },

  Milestone: (
    data: ArticleEntryData,
    tableIndex: number,
    groupShellIndex: number,
  ) => {
    return (
      data?.Deals?.["Licensee Table"]?.[tableIndex][
        "Strategic Collaboration & License Agreement terms"
      ]["Milestone Payment and Condition"] || []
    );
  },
  [LICENSE_AGREEMENT_SUP_GROUP_SHELL_KEYS.otherPaymentAndDetail]: (
    data: ArticleEntryData,
    tableIndex: number,
    groupShellIndex: number,
  ) => {
    return (
      data?.Deals?.[ENTRY_DATA_LICENSEE_TABLE]?.[tableIndex][
        ENTRY_DATA_LICENSEE_TABLE_KEYS
          .strategicCollaborationLicenseAgreementTerms
      ][
        ENTRY_DATA_STRATEGIC_COLLABORATION_LICENSE_AGREEMENT_TERMS_KEYS
          .otherPaymentAndDetailScLa
      ] || []
    );
  },
  [CROSS_LICENSE_AGREEMENT_SUP_GROUP_SHELL_KEYS.rightsScopePartnerA]: (
    data: ArticleEntryData,
    tableIndex: number,
    groupShellIndex: number,
  ) => {
    return data?.Deals?.["Licensee Table"]?.[tableIndex]["Rights Scope"] || [];
  },
  [CROSS_LICENSE_AGREEMENT_SUP_GROUP_SHELL_KEYS.rightsScopePartnerB]: (
    data: ArticleEntryData,
    tableIndex: number,
    groupShellIndex: number,
  ) => {
    return data?.Deals?.["Licensee Table"]?.[tableIndex]["Rights Scope"] || [];
  },
  [MERGE_ACQUISITION_SUB_GROUP_SHELL_KEYS.contingentPayment]: (
    data: ArticleEntryData,
    tableIndex: number,
    groupShellIndex: number,
  ) => {
    return (
      data?.Deals?.[ENTRY_DATA_LICENSEE_TABLE]?.[tableIndex][
        ENTRY_DATA_LICENSEE_TABLE_KEYS.mergeAcquisitionTerms
      ][ENTRY_DATA_MERGE_ACQUISITION_TERMS_KEYS.contingentPayment] || []
    );
  },
  [CLINICAL_TRIAL_DESIGN_SUB_GROUP_SHELL_KEYS.arm]: (
    data: ArticleEntryData,
    tableIndex: number,
    groupShellIndex: number,
  ) => {
    return (
      data?.[ENTRY_DATA_SECTION_KEYS.clinicalTrial]?.[
        ENTRY_DATA_CLINICAL_TRIAL_DESIGN
      ]?.[tableIndex][
        ENTRY_DATA_CLINICAL_TRIAL_DESIGN_KEYS.clinicalTrialDesign2
      ] || []
    );
  },
  [VENTURE_FORMATION_SUB_GROUP_SHELL_KEYS.contingentInvestment]: (
    data: ArticleEntryData,
    tableIndex: number,
    groupShellIndex: number,
  ) => {
    return (
      data?.Deals?.[ENTRY_DATA_LICENSEE_TABLE]?.[tableIndex][
        ENTRY_DATA_LICENSEE_TABLE_KEYS.ventureFormationTerms
      ]?.[
        ENTRY_DATA_VENTURE_FORMATION_TERMS_KEYS.contingentInvestmentAndDetailVf
      ] || []
    );
  },
};

export const SUB_GROUP_SHELL_PATH_TO_ADD_SUB_GROUP_SHELL_DEAL_FILING: Record<
  string,
  (
    data: ArticleEntryData,
    tableIndex: number,
    groupShellIndex: number,
  ) => unknown[]
> = {
  Milestone: (
    data: ArticleEntryData,
    tableIndex: number,
    groupShellIndex: number,
  ) => {
    return (
      data?.["Deal Filing"]?.["Licensee Table"]?.[tableIndex][
        "Strategic Collaboration & License Agreement terms"
      ]["Milestone Payment and Condition"] || []
    );
  },
  [LICENSE_AGREEMENT_SUP_GROUP_SHELL_KEYS.otherPaymentAndDetail]: (
    data: ArticleEntryData,
    tableIndex: number,
    groupShellIndex: number,
  ) => {
    return (
      data?.["Deal Filing"]?.[ENTRY_DATA_LICENSEE_TABLE]?.[tableIndex][
        ENTRY_DATA_LICENSEE_TABLE_KEYS
          .strategicCollaborationLicenseAgreementTerms
      ][
        ENTRY_DATA_STRATEGIC_COLLABORATION_LICENSE_AGREEMENT_TERMS_KEYS
          .otherPaymentAndDetailScLa
      ] || []
    );
  },
  [CROSS_LICENSE_AGREEMENT_SUP_GROUP_SHELL_KEYS.rightsScopePartnerA]: (
    data: ArticleEntryData,
    tableIndex: number,
    groupShellIndex: number,
  ) => {
    return (
      data?.["Deal Filing"]?.["Licensee Table"]?.[tableIndex]["Rights Scope"] ||
      []
    );
  },
  [CROSS_LICENSE_AGREEMENT_SUP_GROUP_SHELL_KEYS.rightsScopePartnerB]: (
    data: ArticleEntryData,
    tableIndex: number,
    groupShellIndex: number,
  ) => {
    return (
      data?.["Deal Filing"]?.["Licensee Table"]?.[tableIndex]["Rights Scope"] ||
      []
    );
  },
  [MERGE_ACQUISITION_SUB_GROUP_SHELL_KEYS.contingentPayment]: (
    data: ArticleEntryData,
    tableIndex: number,
    groupShellIndex: number,
  ) => {
    return (
      data?.["Deal Filing"]?.[ENTRY_DATA_LICENSEE_TABLE]?.[tableIndex][
        ENTRY_DATA_LICENSEE_TABLE_KEYS.mergeAcquisitionTerms
      ][ENTRY_DATA_MERGE_ACQUISITION_TERMS_KEYS.contingentPayment] || []
    );
  },
  [CLINICAL_TRIAL_DESIGN_SUB_GROUP_SHELL_KEYS.arm]: (
    data: ArticleEntryData,
    tableIndex: number,
    groupShellIndex: number,
  ) => {
    return (
      data?.[ENTRY_DATA_SECTION_KEYS.clinicalTrial]?.[
        ENTRY_DATA_CLINICAL_TRIAL_DESIGN
      ]?.[tableIndex][
        ENTRY_DATA_CLINICAL_TRIAL_DESIGN_KEYS.clinicalTrialDesign2
      ] || []
    );
  },
  [VENTURE_FORMATION_SUB_GROUP_SHELL_KEYS.contingentInvestment]: (
    data: ArticleEntryData,
    tableIndex: number,
    groupShellIndex: number,
  ) => {
    return (
      data?.["Deal Filing"]?.[ENTRY_DATA_LICENSEE_TABLE]?.[tableIndex][
        ENTRY_DATA_LICENSEE_TABLE_KEYS.ventureFormationTerms
      ]?.[
        ENTRY_DATA_VENTURE_FORMATION_TERMS_KEYS.contingentInvestmentAndDetailVf
      ] || []
    );
  },
};

export const BASIC_DATA_FOR_ADDING_SUB_GROUP_SHELLS: Record<
  string,
  Record<
    string,
    (
      data: ArticleEntryData,
    ) =>
      | RightsScope
      | MilestonePaymentAndCondition
      | OtherPaymentAndDetail
      | ContingentPayment
      | ArmValue
      | ContingentInvestmentVf
      | DealLaScRightsScopeTableValue
      | DealLaScMilestonePaymentAndDetailSubGroupValue
      | DealLaScOtherPaymentAndDetailSubGroupValue
      | DealLaScAdvisorTableValue
      | DealLaScRoyaltySubGroupValue
      | DealLaScPartnerAValue
      | DealLaScPartnerBValue
      | DealLaScPartnerCValue
      | DealsAdvisorTableValue
      | LicensorMAValue
      | LicenseeMAValue
  >
> = {
  [ENTRY_DATA_SECTION_KEYS.deals]: {
    "Rights Scope": (data: ArticleEntryData) => {
      const createAttributionId = () => createRandomString(8);
      const rightScopeGroupShellData =
        data.Deals?.["Licensee Table"]?.[0]["Rights Scope"]?.[0];

      return {
        Drug: {
          value: [],
          options: rightScopeGroupShellData?.Drug.options,
          attributionId: createAttributionId(),
        },
        Indication: {
          value: [],
          options: rightScopeGroupShellData?.Indication.options,
          attributionId: createAttributionId(),
        },
        Exclusivity: {
          value: [],
          options: rightScopeGroupShellData?.Exclusivity.options,
          attributionId: createAttributionId(),
        },
        Territory: {
          value: [],
          options: rightScopeGroupShellData?.Territory.options,
          attributionId: createAttributionId(),
        },
      } as RightsScope;
    },
    [VENTURE_FORMATION_SUB_GROUP_SHELL_KEYS.contingentInvestment]: (
      data: ArticleEntryData,
    ) => {
      const createAttributionId = () => createRandomString(8);
      const contingentPaymentData =
        data.Deals?.[ENTRY_DATA_LICENSEE_TABLE]?.[0][
          ENTRY_DATA_LICENSEE_TABLE_KEYS.ventureFormationTerms
        ][
          ENTRY_DATA_VENTURE_FORMATION_TERMS_KEYS
            .contingentInvestmentAndDetailVf
        ][0];

      return {
        [ENTRY_DATA_VENTURE_FORMATION_TERMS_KEYS.contingentInvestmentVf]: {
          value: [],
          options:
            contingentPaymentData?.[
              ENTRY_DATA_VENTURE_FORMATION_TERMS_KEYS.contingentInvestmentVf
            ].options,
          attributionId: createAttributionId(),
        },
        [ENTRY_DATA_VENTURE_FORMATION_TERMS_KEYS.contingentDetailVf]: {
          value: [],
          options:
            contingentPaymentData?.[
              ENTRY_DATA_VENTURE_FORMATION_TERMS_KEYS.contingentDetailVf
            ].options,
          attributionId: createAttributionId(),
        },
      } as ContingentInvestmentVf;
    },

    [CROSS_LICENSE_AGREEMENT_SUP_GROUP_SHELL_KEYS.rightsScopePartnerA]: (
      data: ArticleEntryData,
    ) => {
      const createAttributionId = () => createRandomString(8);
      const rightScopeGroupShellData =
        data.Deals?.["Licensee Table"]?.[0]["Rights Scope"]?.[0];

      return {
        Drug: {
          value: [],
          options: rightScopeGroupShellData?.Drug.options,
          attributionId: createAttributionId(),
        },
        Indication: {
          value: [],
          options: rightScopeGroupShellData?.Indication.options,
          attributionId: createAttributionId(),
        },
        Exclusivity: {
          value: [],
          options: rightScopeGroupShellData?.Exclusivity.options,
          attributionId: createAttributionId(),
        },
        Territory: {
          value: [],
          options: rightScopeGroupShellData?.Territory.options,
          attributionId: createAttributionId(),
        },
      } as RightsScope;
    },
    [CROSS_LICENSE_AGREEMENT_SUP_GROUP_SHELL_KEYS.rightsScopePartnerB]: (
      data: ArticleEntryData,
    ) => {
      const createAttributionId = () => createRandomString(8);
      const rightScopeGroupShellData =
        data.Deals?.["Licensee Table"]?.[0]["Rights Scope"]?.[0];

      return {
        Drug: {
          value: [],
          options: rightScopeGroupShellData?.Drug.options,
          attributionId: createAttributionId(),
        },
        Indication: {
          value: [],
          options: rightScopeGroupShellData?.Indication.options,
          attributionId: createAttributionId(),
        },
        Exclusivity: {
          value: [],
          options: rightScopeGroupShellData?.Exclusivity.options,
          attributionId: createAttributionId(),
        },
        Territory: {
          value: [],
          options: rightScopeGroupShellData?.Territory.options,
          attributionId: createAttributionId(),
        },
      } as RightsScope;
    },

    Milestone: (data: ArticleEntryData) => {
      const createAttributionId = () => createRandomString(8);
      const milestoneShellData =
        data.Deals?.["Licensee Table"]?.[0][
          "Strategic Collaboration & License Agreement terms"
        ]["Milestone Payment and Condition"][0];

      return {
        "Milestone Payment": {
          value: [],
          options: milestoneShellData?.["Milestone Payment"].options,
          attributionId: createAttributionId(),
        },
        "Milestone Condition Title": {
          value: [],
          options: milestoneShellData?.["Milestone Condition Title"].options,
          attributionId: createAttributionId(),
        },
      } as MilestonePaymentAndCondition;
    },

    [LICENSE_AGREEMENT_SUP_GROUP_SHELL_KEYS.otherPaymentAndDetail]: (
      data: ArticleEntryData,
    ) => {
      const createAttributionId = () => createRandomString(8);
      const otherPaymentShellData =
        data.Deals?.[ENTRY_DATA_LICENSEE_TABLE]?.[0][
          ENTRY_DATA_LICENSEE_TABLE_KEYS
            .strategicCollaborationLicenseAgreementTerms
        ][
          ENTRY_DATA_STRATEGIC_COLLABORATION_LICENSE_AGREEMENT_TERMS_KEYS
            .otherPaymentAndDetailScLa
        ][0];

      return {
        [ENTRY_DATA_OTHER_PAYMENT_DETAIL_KEYS.otherPaymentScLa]: {
          value: [],
          options:
            otherPaymentShellData?.[
              ENTRY_DATA_OTHER_PAYMENT_DETAIL_KEYS.otherPaymentScLa
            ].options,
          attributionId: createAttributionId(),
        },
        [ENTRY_DATA_OTHER_PAYMENT_DETAIL_KEYS.otherPaymentDetailScLa]: {
          value: [],
          options:
            otherPaymentShellData?.[
              ENTRY_DATA_OTHER_PAYMENT_DETAIL_KEYS.otherPaymentDetailScLa
            ].options,
          attributionId: createAttributionId(),
        },
      } as OtherPaymentAndDetail;
    },

    [MERGE_ACQUISITION_SUB_GROUP_SHELL_KEYS.contingentPayment]: (
      data: ArticleEntryData,
    ) => {
      const createAttributionId = () => createRandomString(8);
      const contingentPaymentData =
        data.Deals?.[ENTRY_DATA_LICENSEE_TABLE]?.[0][
          ENTRY_DATA_LICENSEE_TABLE_KEYS.mergeAcquisitionTerms
        ][ENTRY_DATA_MERGE_ACQUISITION_TERMS_KEYS.contingentPayment][0];

      return {
        [ENTRY_DATA_CONTINGENT_PAYMENT_KEYS.contingentMilestoneMa]: {
          value: [],
          options:
            contingentPaymentData?.[
              ENTRY_DATA_CONTINGENT_PAYMENT_KEYS.contingentMilestoneMa
            ].options,
          attributionId: createAttributionId(),
        },
        [ENTRY_DATA_CONTINGENT_PAYMENT_KEYS.contingentPaymentMa]: {
          value: [],
          options:
            contingentPaymentData?.[
              ENTRY_DATA_CONTINGENT_PAYMENT_KEYS.contingentPaymentMa
            ].options,
          attributionId: createAttributionId(),
        },
        [ENTRY_DATA_CONTINGENT_PAYMENT_KEYS.contingentPricePerShareMa]: {
          value: [],
          options:
            contingentPaymentData?.[
              ENTRY_DATA_CONTINGENT_PAYMENT_KEYS.contingentPricePerShareMa
            ].options,
          attributionId: createAttributionId(),
        },
      } as ContingentPayment;
    },
    Advisor: (data: ArticleEntryData) => {
      const createAttributionId = () => createRandomString(8);
      const advisorData = data?.Deals?.["Advisor Table"]?.[0];

      return {
        "Advisor Name": {
          value: [],
          options: advisorData?.["Advisor Name"]?.options,
          attributionId: createAttributionId(),
        },
        "Party Axis": {
          value: [],
          options: advisorData?.["Party Axis"]?.options,
          attributionId: createAttributionId(),
        },
        "Advisor Role": {
          value: [],
          options: advisorData?.["Advisor Role"]?.options,
          attributionId: createAttributionId(),
        },
      } as DealsAdvisorTableValue;
    },
    "Key Comment List": () =>
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ({
        "Comment Quote": { value: [], options: [] },
        "Comment Spokesperson": { value: [], options: [] },
      } as any),
    "Licensor(MA)": (data: ArticleEntryData) => {
      const createAttributionId = () => createRandomString(8);
      const sample = data?.Deals?.["Licensor Table"]?.["Licensor(MA)"]?.[0];

      return {
        "Licensor Name(MA)": {
          value: [],
          options: sample?.["Licensor Name(MA)"]?.options,
          attributionId: createAttributionId(),
        },
        "Licensor Relationship Context(MA)": {
          value: [],
          options: sample?.["Licensor Relationship Context(MA)"]?.options,
          attributionId: createAttributionId(),
        },
      } as LicensorMAValue;
    },
    "Licensee(MA)": (data: ArticleEntryData) => {
      const createAttributionId = () => createRandomString(8);
      const sample =
        data?.Deals?.["Licensee Table"]?.[0]?.["Licensee(MA)"]?.[0];

      return {
        "Licensee Name(MA)": {
          value: [],
          options: sample?.["Licensee Name(MA)"]?.options,
          attributionId: createAttributionId(),
        },
        "Licensee Relationship Context(MA)": {
          value: [],
          options: sample?.["Licensee Relationship Context(MA)"]?.options,
          attributionId: createAttributionId(),
        },
      } as LicenseeMAValue;
    },
    "Licensor(VF)": (data: ArticleEntryData) => {
      const createAttributionId = () => createRandomString(8);
      const sample = data?.Deals?.["Licensor Table"]?.["Licensor(VF)"]?.[0];

      return {
        "Licensor Name(VF)": {
          value: [],
          options: sample?.["Licensor Name(VF)"]?.options,
          attributionId: createAttributionId(),
        },
        "Licensor Relationship Context(VF)": {
          value: [],
          options: sample?.["Licensor Relationship Context(VF)"]?.options,
          attributionId: createAttributionId(),
        },
      } as LicensorVfValue;
    },
    "Licensee(VF)": (data: ArticleEntryData) => {
      const createAttributionId = () => createRandomString(8);
      const sample =
        data?.Deals?.["Licensee Table"]?.[0]?.["Licensee(VF)"]?.[0];

      return {
        "Licensee Name(VF)": {
          value: [],
          options: sample?.["Licensee Name(VF)"]?.options,
          attributionId: createAttributionId(),
        },
        "Licensee Relationship Context(VF)": {
          value: [],
          options: sample?.["Licensee Relationship Context(VF)"]?.options,
          attributionId: createAttributionId(),
        },
      } as LicenseeVfValue;
    },
    "Asset Transfer Row": (data: ArticleEntryData) => {
      const createAttributionId = () => createRandomString(8);
      const sample =
        data?.Deals?.["Licensee Table"]?.[0]?.["Rights Scope"]?.[0];

      return {
        Drug: {
          value: [],
          options: sample?.Drug?.options ?? [],
          attributionId: createAttributionId(),
        },
        Indication: {
          value: [],
          options: sample?.Indication?.options ?? [],
          attributionId: createAttributionId(),
        },
        Exclusivity: {
          value: [],
          options: sample?.Exclusivity?.options ?? [],
          attributionId: createAttributionId(),
        },
        Territory: {
          value: [],
          options: sample?.Territory?.options ?? [],
          attributionId: createAttributionId(),
        },
        "Territory Include": {
          value: [],
          options: sample?.["Territory Include"]?.options ?? [],
          attributionId: createAttributionId(),
        },
        "Territory Exclude": {
          value: [],
          options: sample?.["Territory Exclude"]?.options ?? [],
          attributionId: createAttributionId(),
        },
      } as RightsScope;
    },
  },
  [ENTRY_DATA_SECTION_KEYS.dealsLaSc]: {
    "Rights Scope": (data: ArticleEntryData) => {
      const createAttributionId = () => createRandomString(8);
      const rightScopeGroupShellData =
        data[ENTRY_DATA_SECTION_KEYS.dealsLaSc]?.["Rights Scope Table"]?.[0];

      return {
        attributionInfo: {
          attributionId: createAttributionId(),
        },
        Asset: {
          value: [],
          options: rightScopeGroupShellData?.Asset.options,
          attributionId: createAttributionId(),
        },
        Exclusivity: {
          value: [],
          options: rightScopeGroupShellData?.Exclusivity.options,
          attributionId: createAttributionId(),
        },
        "Intended Use": {
          value: [],
          options: rightScopeGroupShellData?.["Intended Use"].options,
          attributionId: createAttributionId(),
        },
        "Rights Limitation": {
          value: [],
          options: rightScopeGroupShellData?.["Rights Limitation"].options,
          attributionId: createAttributionId(),
        },
        "Rights Scope": {
          value: [],
          options: rightScopeGroupShellData?.["Rights Scope"].options,
          attributionId: createAttributionId(),
        },
        "Rights Scope Type": {
          value: [],
          options: rightScopeGroupShellData?.["Rights Scope Type"].options,
          attributionId: createAttributionId(),
        },
        Territory: {
          value: [],
          options: rightScopeGroupShellData?.Territory.options,
          attributionId: createAttributionId(),
        },
        "Territory Exclude": {
          value: [],
          options: rightScopeGroupShellData?.["Territory Exclude"].options,
          attributionId: createAttributionId(),
        },
        "Territory Include": {
          value: [],
          options: rightScopeGroupShellData?.["Territory Include"].options,
          attributionId: createAttributionId(),
        },
        "Rights Flow": {
          "Axis Direction": {
            value: [],
            options:
              rightScopeGroupShellData?.["Rights Flow"]?.["Axis Direction"]
                .options,
            attributionId: createAttributionId(),
          },
          "Benefiting Axis": {
            value: [],
            options:
              rightScopeGroupShellData?.["Rights Flow"]?.["Benefiting Axis"]
                .options,
            attributionId: createAttributionId(),
          },
          "Contributing Axis": {
            value: [],
            options:
              rightScopeGroupShellData?.["Rights Flow"]?.["Contributing Axis"]
                .options,
            attributionId: createAttributionId(),
          },
        },
      } as DealLaScRightsScopeTableValue;
    },
    Advisor: (data: ArticleEntryData) => {
      const createAttributionId = () => createRandomString(8);
      const advisorData =
        data[ENTRY_DATA_SECTION_KEYS.dealsLaSc]?.["Advisor Table"]?.[0];

      return {
        attributionInfo: {
          attributionId: createAttributionId(),
        },
        "Advisor Name": {
          value: [],
          options: advisorData?.["Advisor Name"]?.options,
          attributionId: createAttributionId(),
        },
        "Party Axis": {
          value: [],
          options: advisorData?.["Party Axis"]?.options,
          attributionId: createAttributionId(),
        },
        "Advisor Role": {
          value: [],
          options: advisorData?.["Advisor Role"]?.options,
          attributionId: createAttributionId(),
        },
      } as DealLaScAdvisorTableValue;
    },

    "Partner A": (data: ArticleEntryData) => {
      const createAttributionId = () => createRandomString(8);
      const partnerAData =
        data?.[ENTRY_DATA_SECTION_KEYS.dealsLaSc]?.["Partner Axis"]?.[
          "Partner A"
        ]?.[0];

      return {
        attributionInfo: {
          attributionId: createAttributionId(),
        },
        "Partner A Name": {
          value: [],
          options: partnerAData?.["Partner A Name"]?.options,
          attributionId: createAttributionId(),
        },
        "Partner A Relationship Context": {
          value: [],
          options: partnerAData?.["Partner A Relationship Context"]?.options,
          attributionId: createAttributionId(),
        },
      } as DealLaScPartnerAValue;
    },

    "Partner B": (data: ArticleEntryData) => {
      const createAttributionId = () => createRandomString(8);
      const partnerAData =
        data?.[ENTRY_DATA_SECTION_KEYS.dealsLaSc]?.["Partner Axis"]?.[
          "Partner B"
        ]?.[0];

      return {
        attributionInfo: {
          attributionId: createAttributionId(),
        },
        "Partner B Name": {
          value: [],
          options: partnerAData?.["Partner B Name"]?.options,
          attributionId: createAttributionId(),
        },
        "Partner B Relationship Context": {
          value: [],
          options: partnerAData?.["Partner B Relationship Context"]?.options,
          attributionId: createAttributionId(),
        },
      } as DealLaScPartnerBValue;
    },

    "Partner C": (data: ArticleEntryData) => {
      const createAttributionId = () => createRandomString(8);
      const partnerAData =
        data?.[ENTRY_DATA_SECTION_KEYS.dealsLaSc]?.["Partner Axis"]?.[
          "Partner C"
        ]?.[0];

      return {
        attributionInfo: {
          attributionId: createAttributionId(),
        },
        "Partner C Name": {
          value: [],
          options: partnerAData?.["Partner C Name"]?.options,
          attributionId: createAttributionId(),
        },
        "Partner C Relationship Context": {
          value: [],
          options: partnerAData?.["Partner C Relationship Context"]?.options,
          attributionId: createAttributionId(),
        },
      } as DealLaScPartnerCValue;
    },

    "Milestone Payment And Detail": (data: ArticleEntryData) => {
      const createAttributionId = () => createRandomString(8);
      const milestoneShellData =
        data[ENTRY_DATA_SECTION_KEYS.dealsLaSc]?.[
          "Main Financial Terms Table"
        ]?.[0]["Milestone Payment And Detail"][0];

      return {
        "Milestone Payment(LA&SC)": {
          value: [],
          options: milestoneShellData?.["Milestone Payment(LA&SC)"].options,
          attributionId: createAttributionId(),
        },
        "Milestone Payment Detail(LA&SC)": {
          value: [],
          options:
            milestoneShellData?.["Milestone Payment Detail(LA&SC)"].options,
          attributionId: createAttributionId(),
        },
      } as DealLaScMilestonePaymentAndDetailSubGroupValue;
    },
    "Other Payment And Detail": (data: ArticleEntryData) => {
      const createAttributionId = () => createRandomString(8);
      const otherPaymentShellData =
        data[ENTRY_DATA_SECTION_KEYS.dealsLaSc]?.[
          "Main Financial Terms Table"
        ]?.[0]["Other Payment And Detail"][0];

      return {
        "Other Payment(LA&SC)": {
          value: [],
          options: otherPaymentShellData?.["Other Payment(LA&SC)"].options,
          attributionId: createAttributionId(),
        },
        "Other Payment Detail(LA&SC)": {
          value: [],
          options:
            otherPaymentShellData?.["Other Payment Detail(LA&SC)"].options,
          attributionId: createAttributionId(),
        },
      } as DealLaScOtherPaymentAndDetailSubGroupValue;
    },
    "Royalty(LA&SC)": (data: ArticleEntryData) => {
      const createAttributionId = () => createRandomString(8);
      const royaltyShellData =
        data[ENTRY_DATA_SECTION_KEYS.dealsLaSc]?.[
          "Main Financial Terms Table"
        ]?.[0]["Royalty(LA&SC)"][0];

      return {
        "Royalty Rate": {
          value: [],
          options: royaltyShellData?.["Royalty Rate"].options,
          attributionId: createAttributionId(),
        },
        "Royalty Detail": {
          value: [],
          options: royaltyShellData?.["Royalty Detail"].options,
          attributionId: createAttributionId(),
        },
      } as DealLaScRoyaltySubGroupValue;
    },
  },
  [ENTRY_DATA_SECTION_KEYS.dealFiling]: {
    "Rights Scope": (data: ArticleEntryData) => {
      const createAttributionId = () => createRandomString(8);
      const rightScopeGroupShellData =
        data?.["Deal Filing"]?.["Licensee Table"]?.[0]["Rights Scope"]?.[0];

      return {
        Drug: {
          value: [],
          options: rightScopeGroupShellData?.Drug.options,
          attributionId: createAttributionId(),
        },
        Indication: {
          value: [],
          options: rightScopeGroupShellData?.Indication.options,
          attributionId: createAttributionId(),
        },
        Exclusivity: {
          value: [],
          options: rightScopeGroupShellData?.Exclusivity.options,
          attributionId: createAttributionId(),
        },
        Territory: {
          value: [],
          options: rightScopeGroupShellData?.Territory.options,
          attributionId: createAttributionId(),
        },
      } as RightsScope;
    },
    [VENTURE_FORMATION_SUB_GROUP_SHELL_KEYS.contingentInvestment]: (
      data: ArticleEntryData,
    ) => {
      const createAttributionId = () => createRandomString(8);
      const contingentPaymentData =
        data?.["Deal Filing"]?.[ENTRY_DATA_LICENSEE_TABLE]?.[0][
          ENTRY_DATA_LICENSEE_TABLE_KEYS.ventureFormationTerms
        ][
          ENTRY_DATA_VENTURE_FORMATION_TERMS_KEYS
            .contingentInvestmentAndDetailVf
        ][0];

      return {
        [ENTRY_DATA_VENTURE_FORMATION_TERMS_KEYS.contingentInvestmentVf]: {
          value: [],
          options:
            contingentPaymentData?.[
              ENTRY_DATA_VENTURE_FORMATION_TERMS_KEYS.contingentInvestmentVf
            ].options,
          attributionId: createAttributionId(),
        },
        [ENTRY_DATA_VENTURE_FORMATION_TERMS_KEYS.contingentDetailVf]: {
          value: [],
          options:
            contingentPaymentData?.[
              ENTRY_DATA_VENTURE_FORMATION_TERMS_KEYS.contingentDetailVf
            ].options,
          attributionId: createAttributionId(),
        },
      } as ContingentInvestmentVf;
    },

    [CROSS_LICENSE_AGREEMENT_SUP_GROUP_SHELL_KEYS.rightsScopePartnerA]: (
      data: ArticleEntryData,
    ) => {
      const createAttributionId = () => createRandomString(8);
      const rightScopeGroupShellData =
        data?.["Deal Filing"]?.["Licensee Table"]?.[0]["Rights Scope"]?.[0];

      return {
        Drug: {
          value: [],
          options: rightScopeGroupShellData?.Drug.options,
          attributionId: createAttributionId(),
        },
        Indication: {
          value: [],
          options: rightScopeGroupShellData?.Indication.options,
          attributionId: createAttributionId(),
        },
        Exclusivity: {
          value: [],
          options: rightScopeGroupShellData?.Exclusivity.options,
          attributionId: createAttributionId(),
        },
        Territory: {
          value: [],
          options: rightScopeGroupShellData?.Territory.options,
          attributionId: createAttributionId(),
        },
      } as RightsScope;
    },
    [CROSS_LICENSE_AGREEMENT_SUP_GROUP_SHELL_KEYS.rightsScopePartnerB]: (
      data: ArticleEntryData,
    ) => {
      const createAttributionId = () => createRandomString(8);
      const rightScopeGroupShellData =
        data?.["Deal Filing"]?.["Licensee Table"]?.[0]["Rights Scope"]?.[0];

      return {
        Drug: {
          value: [],
          options: rightScopeGroupShellData?.Drug.options,
          attributionId: createAttributionId(),
        },
        Indication: {
          value: [],
          options: rightScopeGroupShellData?.Indication.options,
          attributionId: createAttributionId(),
        },
        Exclusivity: {
          value: [],
          options: rightScopeGroupShellData?.Exclusivity.options,
          attributionId: createAttributionId(),
        },
        Territory: {
          value: [],
          options: rightScopeGroupShellData?.Territory.options,
          attributionId: createAttributionId(),
        },
      } as RightsScope;
    },

    Milestone: (data: ArticleEntryData) => {
      const createAttributionId = () => createRandomString(8);
      const milestoneShellData =
        data?.["Deal Filing"]?.["Licensee Table"]?.[0][
          "Strategic Collaboration & License Agreement terms"
        ]["Milestone Payment and Condition"][0];

      return {
        "Milestone Payment": {
          value: [],
          options: milestoneShellData?.["Milestone Payment"].options,
          attributionId: createAttributionId(),
        },
        "Milestone Condition Title": {
          value: [],
          options: milestoneShellData?.["Milestone Condition Title"].options,
          attributionId: createAttributionId(),
        },
      } as MilestonePaymentAndCondition;
    },

    [LICENSE_AGREEMENT_SUP_GROUP_SHELL_KEYS.otherPaymentAndDetail]: (
      data: ArticleEntryData,
    ) => {
      const createAttributionId = () => createRandomString(8);
      const otherPaymentShellData =
        data?.["Deal Filing"]?.[ENTRY_DATA_LICENSEE_TABLE]?.[0][
          ENTRY_DATA_LICENSEE_TABLE_KEYS
            .strategicCollaborationLicenseAgreementTerms
        ][
          ENTRY_DATA_STRATEGIC_COLLABORATION_LICENSE_AGREEMENT_TERMS_KEYS
            .otherPaymentAndDetailScLa
        ][0];

      return {
        [ENTRY_DATA_OTHER_PAYMENT_DETAIL_KEYS.otherPaymentScLa]: {
          value: [],
          options:
            otherPaymentShellData?.[
              ENTRY_DATA_OTHER_PAYMENT_DETAIL_KEYS.otherPaymentScLa
            ].options,
          attributionId: createAttributionId(),
        },
        [ENTRY_DATA_OTHER_PAYMENT_DETAIL_KEYS.otherPaymentDetailScLa]: {
          value: [],
          options:
            otherPaymentShellData?.[
              ENTRY_DATA_OTHER_PAYMENT_DETAIL_KEYS.otherPaymentDetailScLa
            ].options,
          attributionId: createAttributionId(),
        },
      } as OtherPaymentAndDetail;
    },

    [MERGE_ACQUISITION_SUB_GROUP_SHELL_KEYS.contingentPayment]: (
      data: ArticleEntryData,
    ) => {
      const createAttributionId = () => createRandomString(8);
      const contingentPaymentData =
        data?.["Deal Filing"]?.[ENTRY_DATA_LICENSEE_TABLE]?.[0][
          ENTRY_DATA_LICENSEE_TABLE_KEYS.mergeAcquisitionTerms
        ][ENTRY_DATA_MERGE_ACQUISITION_TERMS_KEYS.contingentPayment][0];

      return {
        [ENTRY_DATA_CONTINGENT_PAYMENT_KEYS.contingentMilestoneMa]: {
          value: [],
          options:
            contingentPaymentData?.[
              ENTRY_DATA_CONTINGENT_PAYMENT_KEYS.contingentMilestoneMa
            ].options,
          attributionId: createAttributionId(),
        },
        [ENTRY_DATA_CONTINGENT_PAYMENT_KEYS.contingentPaymentMa]: {
          value: [],
          options:
            contingentPaymentData?.[
              ENTRY_DATA_CONTINGENT_PAYMENT_KEYS.contingentPaymentMa
            ].options,
          attributionId: createAttributionId(),
        },
        [ENTRY_DATA_CONTINGENT_PAYMENT_KEYS.contingentPricePerShareMa]: {
          value: [],
          options:
            contingentPaymentData?.[
              ENTRY_DATA_CONTINGENT_PAYMENT_KEYS.contingentPricePerShareMa
            ].options,
          attributionId: createAttributionId(),
        },
      } as ContingentPayment;
    },
  },
  [ENTRY_DATA_SECTION_KEYS.clinicalTrial]: {
    [CLINICAL_TRIAL_DESIGN_SUB_GROUP_SHELL_KEYS.arm]: (
      data: ArticleEntryData,
    ) => {
      const createAttributionId = () => createRandomString(8);
      const clinicalTrialDesign2Data =
        data?.[ENTRY_DATA_SECTION_KEYS.clinicalTrial]?.[
          ENTRY_DATA_CLINICAL_TRIAL_DESIGN
        ]?.[0][ENTRY_DATA_CLINICAL_TRIAL_DESIGN_KEYS.clinicalTrialDesign2][0];

      return {
        [ENTRY_DATA_CLINICAL_TRIAL_DESIGN_2_KEYS.armName]: {
          value: [],
          options:
            clinicalTrialDesign2Data?.[
              ENTRY_DATA_CLINICAL_TRIAL_DESIGN_2_KEYS.armName
            ].options,
          attributionId: createAttributionId(),
        },
        [ENTRY_DATA_CLINICAL_TRIAL_DESIGN_2_KEYS.patientsNumber]: {
          value: [],
          options:
            clinicalTrialDesign2Data?.[
              ENTRY_DATA_CLINICAL_TRIAL_DESIGN_2_KEYS.patientsNumber
            ].options,
          attributionId: createAttributionId(),
        },
        [ENTRY_DATA_CLINICAL_TRIAL_DESIGN_2_KEYS.designGroupInformation]: [
          {
            [ENTRY_DATA_DESIGN_GROUP_INFORMATION_KEYS.does]: {
              value: [],
              options:
                clinicalTrialDesign2Data?.[
                  ENTRY_DATA_CLINICAL_TRIAL_DESIGN_2_KEYS.designGroupInformation
                ][0][ENTRY_DATA_DESIGN_GROUP_INFORMATION_KEYS.does].options,
              attributionId: createAttributionId(),
            },
            [ENTRY_DATA_DESIGN_GROUP_INFORMATION_KEYS.drugName]: {
              value: [],
              options:
                clinicalTrialDesign2Data?.[
                  ENTRY_DATA_CLINICAL_TRIAL_DESIGN_2_KEYS.designGroupInformation
                ][0][ENTRY_DATA_DESIGN_GROUP_INFORMATION_KEYS.drugName].options,
              attributionId: createAttributionId(),
            },
            [ENTRY_DATA_DESIGN_GROUP_INFORMATION_KEYS.duration]: {
              value: [],
              options:
                clinicalTrialDesign2Data?.[
                  ENTRY_DATA_CLINICAL_TRIAL_DESIGN_2_KEYS.designGroupInformation
                ][0][ENTRY_DATA_DESIGN_GROUP_INFORMATION_KEYS.duration].options,
              attributionId: createAttributionId(),
            },
          },
        ],
      } as ArmValue;
    },
  },
};
